import '../styles/checklist.css';

interface ChecklistStep {
  title: string;
  content: string;
}

interface DagAfsluitingProps {
  onComplete: () => void;
  onCancel: () => void;
}

const DAG_AFSLUITING_STEPS: ChecklistStep[] = [
  {
    title: 'VR Brillen Uitzetten',
    content: 'Zet de VR brillen uit door aan de zijkant het knopje 3 tellen ingedrukt te houden. Het lampje gaat uit.'
  },
  {
    title: 'Batterijen Vervangen',
    content: 'Vervang alle batterijen voor zo vol mogelijke batterijen. Zet de oude batterijen terug in de oplader. Controleer of het lampje op de oplader brandt.'
  },
  {
    title: 'Koptelefoons Opladen',
    content: 'Sluit de koptelefoon aan op de USB kabel. Het lampje moet oranje branden.'
  },
  {
    title: 'Ruimte Opruimen',
    content: 'Zorg dat alles netjes schoon is, doekjes in de vuilnisbak, kast afgesloten en de sleutel ingeleverd is.'
  }
];

export default function DagAfsluiting({ onComplete, onCancel }: DagAfsluitingProps) {
  return (
    <div className="checklist-screen">
      <div className="checklist-modal">
        <div className="checklist-header">
          <h2>DagAfsluiting Checklist</h2>
          <p>Voltooi de volgende stappen om de dag af te sluiten</p>
        </div>
        <div className="checklist-body">
          {DAG_AFSLUITING_STEPS.map((step, index) => (
            <div key={index} className="checklist-step">
              <div className="checklist-step-text">
                <div className="checklist-step-number">{index + 1}</div>
                <div className="checklist-step-title">{step.title}</div>
                <div className="checklist-step-content">{step.content}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="checklist-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            Annuleren
          </button>
          <button className="btn btn-primary" onClick={onComplete}>
            Bevestig & Afsluiten
          </button>
        </div>
      </div>
    </div>
  );
}
